var _circle, _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUserAvatar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 18,
    cy: 18,
    r: 18,
    fill: "url(#paint0_linear_4578_97676)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24.6489 23.1249C23.792 21.621 22.4539 20.4491 20.8502 19.798C21.6477 19.1999 22.2368 18.3659 22.5341 17.4143C22.8313 16.4627 22.8217 15.4417 22.5064 14.496C22.1911 13.5502 21.5863 12.7276 20.7775 12.1446C19.9688 11.5617 18.9971 11.248 18.0002 11.248C17.0032 11.248 16.0315 11.5617 15.2228 12.1446C14.414 12.7276 13.8092 13.5502 13.4939 14.496C13.1786 15.4417 13.169 16.4627 13.4662 17.4143C13.7635 18.3659 14.3526 19.1999 15.1502 19.798C13.5464 20.4491 12.2083 21.621 11.3514 23.1249C11.2983 23.2103 11.2629 23.3055 11.2473 23.4048C11.2318 23.5041 11.2363 23.6056 11.2607 23.7031C11.2851 23.8006 11.3289 23.8923 11.3894 23.9725C11.45 24.0528 11.526 24.1201 11.6131 24.1704C11.7001 24.2207 11.7964 24.253 11.8962 24.2653C11.996 24.2777 12.0972 24.2698 12.1939 24.2423C12.2906 24.2147 12.3808 24.168 12.459 24.1049C12.5373 24.0418 12.6021 23.9636 12.6495 23.8749C13.782 21.9174 15.782 20.7499 18.0002 20.7499C20.2183 20.7499 22.2183 21.918 23.3508 23.8749C23.4536 24.0403 23.6167 24.1591 23.8056 24.2064C23.9944 24.2537 24.1943 24.2256 24.3629 24.1282C24.5314 24.0308 24.6555 23.8717 24.7089 23.6845C24.7623 23.4972 24.7408 23.2966 24.6489 23.1249ZM14.7502 15.9999C14.7502 15.3571 14.9408 14.7288 15.2979 14.1943C15.655 13.6599 16.1626 13.2433 16.7564 12.9973C17.3503 12.7513 18.0038 12.687 18.6342 12.8124C19.2646 12.9378 19.8437 13.2473 20.2982 13.7018C20.7528 14.1563 21.0623 14.7354 21.1877 15.3659C21.3131 15.9963 21.2487 16.6498 21.0028 17.2436C20.7568 17.8375 20.3402 18.3451 19.8058 18.7022C19.2713 19.0593 18.6429 19.2499 18.0002 19.2499C17.1385 19.2489 16.3124 18.9062 15.7031 18.2969C15.0939 17.6876 14.7511 16.8616 14.7502 15.9999Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_4578_97676",
    x1: 18,
    y1: 0,
    x2: 18,
    y2: 36,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0B93E3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1074D0"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUserAvatar);
export default __webpack_public_path__ + "static/media/user-avatar.5c3fbd3388daa37df2091fc6e959d468.svg";
export { ForwardRef as ReactComponent };